import React, { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { Typography, Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { MEDIA_BASE_URL, getPortfolioCategory } from "./api";
import "./App.css";

// Fallback data — used if the API returns nothing or fails
const FALLBACK_MACHINES = [
  { name: "CO₂ and N₂O Liquefaction",          redirect: "co2liquefaction",   caption: "For CO₂ Recovery & Generation Plants",                                          imagePath: "/machines-images/CO2 Liquefaction/kanpur_3600kg.jpg" },
  { name: "CO₂ and N₂O Storage",               redirect: "co2tankstorage",    caption: "Maintain CO₂ Pressure in Tanks",                                                imagePath: "/machines-images/CO2 Tank/Abu_70klx3.jpg" },
  { name: "Heat Pumps",                         redirect: "heatpumps",         caption: "For Pools and Bathrooms",                                                       imagePath: "/machines-images/Heat Pump/Machine/Dehradun_Heat_Pump.jpeg" },
  { name: "Climate Control for Mushroom Farms", redirect: "mushroomfarms",     caption: "",                                                                              imagePath: "/machines-images/Mushroom Farms/mushroom.jpeg" },
  { name: "Refrigeration for Slaughterhouse",   redirect: "slaughterhouse",    caption: "",                                                                              imagePath: "/machines-images/Slaughterhouse/slaughterhouse.jpeg" },
  { name: "Ice Machines",                       redirect: "icemachines",       caption: "Tube & Flake",                                                                  imagePath: "/machines-images/Tube Ice Machine/cbpl_52.jpg" },
  { name: "Process Chillers",                   redirect: "processchillers",   caption: "Cooling Oil, Milk, Exo-Gas",                                                    imagePath: "/machines-images/Process Chiller/milkchiller80hp.jpg" },
  { name: "Refrigeration for Potato Storage",   redirect: "coldstores",        caption: "For Fruits, Vegetables and Flowers",                                            imagePath: "/machines-images/Cold Stores/mushroom1.jpeg" },
  { name: "Waste Heat Recovery",                redirect: "wasteheatrecovery", caption: "Hot Water for Pools & Bathrooms from WHR from Power Generators or Chillers",   imagePath: "/machines-images/Waste Heat Recovery/reethi_beach.jpeg" },
];

function App() {
  const navigate = useNavigate();
  const [machines, setMachines] = useState(FALLBACK_MACHINES);

  useEffect(() => {
    getPortfolioCategory("home_page")
      .then((products) => {
        if (!products || products.length === 0) return;
        // Sort by display_order, then map each product to a machine entry
        const sorted = [...products].sort((a, b) => a.display_order - b.display_order);
        const mapped = sorted
          .map((p) => {
            const redirect = p.specs?.redirect;
            if (!redirect) return null;
            // Find fallback for image path default
            const fallback = FALLBACK_MACHINES.find((m) => m.redirect === redirect);
            return {
              name:      p.specs?.name    || fallback?.name    || redirect,
              caption:   p.specs?.caption ?? fallback?.caption ?? "",
              redirect,
              imagePath: p.image_paths?.[0] || fallback?.imagePath || "",
            };
          })
          .filter(Boolean);
        if (mapped.length > 0) setMachines(mapped);
      })
      .catch(() => {}); // silently keep fallback
  }, []);

  return (
    <>
      <Navbar />

      <main className="app-content">
        <div className="app-shell" id="machines">
          {machines.map((machine, index) => {
            const isDarkSection = index % 2 === 0;

            return (
              <section
                key={machine.redirect}
                className={`app-machine-section ${
                  isDarkSection ? "app-machine-section-dark" : "app-machine-section-light"
                }`}
              >
                <Grid
                  container
                  alignItems="center"
                  spacing={{ xs: 4, md: 6 }}
                  direction={{ xs: "column-reverse", md: index % 2 === 0 ? "row" : "row-reverse" }}
                >
                  <Grid item xs={12} md={6}>
                    <div className="app-machine-info">
                      <div className="app-title-and-caption">
                        <Typography className="app-title">{machine.name}</Typography>
                        {machine.caption ? (
                          <Typography className="app-caption">{machine.caption}</Typography>
                        ) : null}
                      </div>

                      <Button
                        onClick={() => navigate(`/product/${machine.redirect}`)}
                        variant="outlined"
                        className="app-explore-btn"
                        sx={{
                          px: { xs: 2, md: 2.5 },
                          py: { xs: 0.75, md: 1 },
                          fontSize: { xs: "16px", md: "18px" },
                          color: "inherit",
                          borderColor: "currentColor",
                          textTransform: "none",
                          borderRadius: "999px",
                          "&:hover": {
                            borderColor: "currentColor",
                            backgroundColor: "rgba(127,127,127,0.08)",
                          },
                        }}
                      >
                        Explore {machine.name}
                      </Button>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <div className="app-image">
                      <img
                        src={`${MEDIA_BASE_URL}${machine.imagePath}`}
                        alt={machine.name}
                        className="app-machine-pic"
                        loading="lazy"
                      />
                    </div>
                  </Grid>
                </Grid>
              </section>
            );
          })}
        </div>
      </main>

      <Footer />
    </>
  );
}

export default App;
